import urls from 'src/constants/constants';
import SearchValidationError from '@/errors/searchValidationError';
import apiAuth from 'src/clients/apiAuth';

export default {
  getSuppliers(searchInput) {
    if (!searchInput || searchInput.length < 3) {
      return throw new SearchValidationError('Search input should be more than 3 letters');
    }
    return apiAuth({
      method: 'get',
      baseURL: urls.url.userService.baseUrl,
      url: urls.url.userService.api.suppliers,
      params: {
        query: searchInput,
      },
    }).then((res) =>
      res.data.map((supplier) => ({
        id: supplier.creditorId,
        email: supplier.email,
        name: supplier.name,
        phoneNumber: supplier.phoneNumber,
      })),
    );
  },
  getSupplierByCreditorId(creditorId) {
    return apiAuth({
      method: 'get',
      baseURL: urls.url.userService.baseUrl,
      url: `${urls.url.userService.api.suppliers}\\${creditorId}`,
    }).then((res) => {
      if (!res.data) throw new Error('Supplier is empty.');
      return {
        id: res.data.creditorId,
        email: res.data.email,
        name: res.data.name,
        phoneNumber: res.data.phoneNumber,
      };
    });
  },
};
